import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
  type?: 'fromUser';
}

const Reply: FC<IProps> = ({ children, type }) => {
  return (
    <div className={classNames(css.reply, { [css[`reply_type_${type}`]]: type })}>
      <div className={css.reply__icon}>
        <Icon id="24--reply" />
      </div>
      <div className={css.reply__text}>{children}</div>
    </div>
  );
};

export default Reply;
